module.exports = "../fonts/HelveticaNeueLTW01-55Roman.eot";


//////////////////
// WEBPACK FOOTER
// ./src/main/script/komodo/fonts/HelveticaNeueLTW01-55Roman.eot
// module id = bSfI
// module chunks = 1